export const TIME_FORMAT = /^(?:[0-5][0-9]):[0-5][0-9]$/;
export const POSTCODE = /^[A-Z]{1,2}[0-9]{1,2}[A-Z]{0,1} ?[0-9][A-Z]{2}$/;
